<template>
  <div>
    <div>
      <b-img
        :src="imgUrl"
        fluid
        alt="Responsive image"
        center
        style="height: 400px; width: 300px"
      ></b-img>
    </div>
    <form class="form-signin" @submit.prevent="login">
      <button class="btn btn-lg btn-secondary btn-block" type="submit">LINE登入</button>
      <!-- <p class="mt-5 mb-3 text-muted" align="center">系統維護中...</p> -->
      <p class="mt-5 mb-3 text-muted" align="center">請使用LINE登入北名實業訂購系統，謝謝</p>
      <p class="mt-5 mb-3 text-muted" align="center">BEIMING CO,. LTD</p>
      <!-- <font-awesome-icon :icon="['fab', 'instagram']" />
         <font-awesome-icon :icon="['fas', 'user-secret']" />
         <font-awesome-icon :icon="['fas', 'user']" /> -->
    </form>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      imgUrl: "../../../static/beiming_logo300.svg",
      login_url: "",
      //  user: {
      //     username: "art0428@gmail.com",
      //     password: "ABC123456"
      //  }
    };
  },
  methods: {
    login() {
      var vm = this;
      window.location.href = this.login_url;
    },
  },
  mounted() {
    let group_suuid = process.env.GROUP_SUUID;
    console.log("GROUP_CODE:", process.env.GROUP_CODE);
    this.login_url = `https://accounts.managers.center/line/login?group_suuid=${group_suuid}`;
    console.log("this.login_url:", this.login_url);
  },
  created() {},
};
</script>

<style scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue